import { useEffect, useState } from 'react';

export default function DifficultyAnalysisTable({ data, selectedSubject }) {
  const [filteredData, setFilteredData] = useState(null);

  useEffect(() => {
    if (!data) return;
    const subjectData = data[selectedSubject?.title?.toLowerCase()];
    if (!subjectData) return;

    const updatedData = Object.fromEntries(
      Object.entries(subjectData).map(([level, stats]) => {
        const totalQuestions = (stats.correct || 0) + (stats.incorrect || 0) + (stats.notAttempted || 0);
        return [level, { ...stats, totalQuestions }];
      }),
    );

    setFilteredData(updatedData);
  }, [selectedSubject, data]);

  if (!data || !filteredData) return null;

  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm w-full">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-75 text-start align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[100px] leading-snug">Difficulty</div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[130px] mx-auto leading-snug text-[var(--q3-green-normal)]">
                Attempted Correct
              </div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-[130px] mx-auto leading-snug text-[var(--q3-danger-normal)]">
                Attempted Wrong
              </div>
            </td>
            <td className="py-3 px-4 min-w-[180px] text-center align-middle">
              <div className="line-clamp-2 max-w-[130px] mx-auto leading-snug text-[var(--q3-neutral-light)]">
                Not Attempted
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          {Object.entries(filteredData)?.map(([key, value], index) => (
            <tr
              key={key}
              className={`border-b border-[var(--q3-stroke-light)] ${
                index === Object.entries(filteredData).length - 1 ? 'border-b-0' : ''
              } hover:bg-[var(--q3-surface-dim)]`}
            >
              <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
                <div className="text-start px-4">
                  <p className="truncate text-base font-medium text-[var(--q3-neutral-default)]">
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </p>
                </div>
              </td>
              <td className="border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-light)] text-xs text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">
                  {value.correct}
                  <span className="text-xs">/{value.totalQuestions} Qs</span>
                </span>
              </td>
              <td className="border-r border-[var(--q3-stroke-light)] text-[var(--q3-neutral-light)] text-xs text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">
                  {value.incorrect}
                  <span className="text-xs">/{value.totalQuestions} Qs</span>
                </span>
              </td>
              <td className="text-center font-medium">
                <span className="text-[var(--q3-neutral-default)] text-base">
                  {value.notAttempted}
                  <span className="text-xs">/{value.totalQuestions} Qs</span>
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
